import { FC, useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import SecondaryButton from "./buttons/SecondaryButton";
import PrimaryButton from "./buttons/PrimaryButton";
import { BackspaceIcon } from "@heroicons/react/24/outline";
import { CheckboxStupid } from "./CheckboxStupid";

interface Props {
  cancel: () => void;
  sendImageToParent: (
    imageURL: string | null,
    sendToWasteStation: boolean,
  ) => void;
  isLoading?: boolean;
  enableSendToWasteStation?: boolean;
  existingSignatureInBase64?: string | null;
}
export const SignatureInput: FC<Props> = ({
  sendImageToParent,
  cancel,
  isLoading = false,
  enableSendToWasteStation,
  existingSignatureInBase64,
}) => {
  const canvasRefSmall = useRef() as React.MutableRefObject<any>;
  const canvasRefLarge = useRef() as React.MutableRefObject<any>;

  const [sendToWasteStation, setSendToWasteStation] = useState(
    !!enableSendToWasteStation,
  );

  const loadSignature = (dataUrl: string) => {
    const img = new Image();
    img.onload = () => {
      const canvas = window.innerWidth < 640 ? canvasRefSmall : canvasRefLarge;
      canvas.current?.fromDataURL(dataUrl);
    };
    img.src = dataUrl;
  };

  useEffect(() => {
    if (existingSignatureInBase64) {
      loadSignature(existingSignatureInBase64);
    }
  }, [existingSignatureInBase64]);

  const onSave = () => {
    if (!canvasRefSmall.current.isEmpty()) {
      sendImageToParent(
        canvasRefSmall.current.getTrimmedCanvas().toDataURL("image/png"),
        sendToWasteStation,
      );
    } else if (!canvasRefLarge.current.isEmpty()) {
      sendImageToParent(
        canvasRefLarge.current.getTrimmedCanvas().toDataURL("image/png"),
        sendToWasteStation,
      );
    } else {
      sendImageToParent(null, sendToWasteStation);
      //throw Error("Båda tomma");
    }
  };

  const clear = () => {
    canvasRefSmall.current?.clear();
    canvasRefLarge.current?.clear();
  };

  return (
    <div className="bg-white py-4 sm:pb-0">
      {/* <div className="fixed top-0 left-0 h-screen w-screen bg-white p-4 z-50 sm:pl-24"> */}
      <div className="mb-1 flex justify-end sm:max-w-[408px]">
        <SecondaryButton size="small" onClick={clear}>
          <BackspaceIcon className="mr-1 h-3 w-auto" />
          Rensa
        </SecondaryButton>
      </div>
      <div className="inline-block border border-gray-700 bg-white sm:hidden">
        <SignatureCanvas
          penColor="black"
          canvasProps={{ width: 323, height: 129 }}
          ref={canvasRefSmall}
        />
      </div>
      <div className="hidden border border-gray-700 bg-white sm:inline-block">
        <SignatureCanvas
          penColor="black"
          canvasProps={{ width: 405, height: 162 }}
          ref={canvasRefLarge}
        />
      </div>
      {!!enableSendToWasteStation && (
        <div className="my-2">
          <CheckboxStupid
            name="sendToWasteStation"
            label="Skicka transportdokument till mottagarstation"
            setChecked={setSendToWasteStation}
            checked={sendToWasteStation}
            small
          />
        </div>
      )}
      <div className="flex justify-between sm:max-w-[408px]">
        <SecondaryButton size="medium" onClick={cancel}>
          Avbryt
        </SecondaryButton>
        <PrimaryButton size="large" onClick={onSave} isLoading={isLoading}>
          {`Spara${sendToWasteStation ? " och skicka" : ""}`}
        </PrimaryButton>
      </div>
    </div>
  );
};
